import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {CustomersFilter} from '../components/customers-filter/CustomersFilter';
import {CustomersTable} from '../components/customers-table/CustomersTable';
import {CustomersFooter} from '../components/customers-footer/CustomersFooter';
import FooterBar from '../../_common/components/FooterBar';

export function CustomersCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'customers-list-card'}>
      <CustomersFilter/>
      <CustomersTable/>
      <FooterBar>
        <CustomersFooter/>
      </FooterBar>
    </Card>
  );
}
